$(document).ready( function () {

  if ($(".js-cwr-product-details-main-sliderv2").length > 0) {
      $(".js-cwr-product-details-main-sliderv2").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false
      });
  }

    
  $(".cwr-accordion .cwr-accordion-header").click(function(){
      const content = $(this).next(".cwr-accordion-content");
      const isOpen = content.is(":visible");
  
      // Close all
      $(".cwr-accordion-content").slideUp(150);
      $(".cwr-accordion-header").removeClass("active");
  
      // Toggle only if it wasn't already open
      if (!isOpen) {
        content.slideDown(150);
        $(this).addClass("active");
      }
  });

  $('#subscribeBox').on('click', function (e) {
    // Only toggle if you're NOT clicking the actual checkbox or slider
    if (!$(e.target).is('#subscribeToggle') && !$(e.target).hasClass('slider')) {
      const checkbox = $('#subscribeToggle');
      checkbox.prop('checked', !checkbox.prop('checked')).trigger('change');
    }
  });
  
  
  // $('#subscribeToggle').on('change', function () {
  //   const isChecked = $(this).is(':checked');

  //   // Toggle active class
  //   $('#subscribeBox').toggleClass('active', isChecked);

  //   // Show/hide frequency dropdown
  //   $('#chooseFrequency').toggle(isChecked);

  //   // Optional: toggle product card style
  //   $('.cwr-choose-quantity__wrapper .product__card').toggleClass('subscribe-on', isChecked);
  // });
  $('#subscribeToggle').on('change', function () {
    const isChecked = $(this).is(':checked');
    if (isChecked) {
        $(this).attr('checked', 'checked');
        $('.cwr-choose-quantity__products_onetime').addClass('hide');
        $('.cwr-choose-quantity__products_subscribe').removeClass('hide');
        $('.cwr-choose-quantity__wrapper .cwr-choose-quantity__products_subscribe .product__card').addClass('subscribe-on');
        $('#chooseFrequency').addClass('active');         
        var selector_selling_id = $('.frequancy_selector option:selected').attr('data-id');
        var selector_vid = $('.cwr-choose-quantity__products_subscribe .product__card.subscribe-on input:checked').attr('data-variant-id');
        $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', selector_selling_id);
        $('.form--product-details-new input[name="variantid"]').val(selector_vid);
        var lastProductSave = $('.product__card.subscribe-on input:checked').next('.product__card-inner').find('.product__save-block .save-tag .sub_price').text();
        $('.cwr-total-you-save__price .save-price__text').text(lastProductSave);
        $('.subscribe-toggle-box .subtext').text('Change, pause or cancel anytime. No questions asked.');
        $('.subscribe-toggle-box').addClass('active');
        var get_text = $('.product__card.subscribe-on input:checked').attr('id');
        if(get_text.includes('2-bottle')){
          $('.cwr-total-you-save__price .best-deal__text').show();
        }else{
          $('.cwr-total-you-save__price .best-deal__text').hide();
        }
      } else {
        $(this).removeAttr('checked');
        $('.cwr-choose-quantity__products_onetime').removeClass('hide');
        $('.cwr-choose-quantity__products_subscribe').addClass('hide');
        $('#chooseFrequency').removeClass('active');
        $('.cwr-choose-quantity__wrapper .cwr-choose-quantity__products_subscribe .product__card').removeClass('subscribe-on');
        var selector_vid = $('.cwr-choose-quantity__products_onetime .product__card input:checked').attr('data-variant-id');
        $('.form--product-details-new input[name="variantid"]').val(selector_vid);
        $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', '');
        var lastProductSave = $('.cwr-choose-quantity__products_onetime .product__card input:checked').next('.product__card-inner').find('.product__save-block .save-tag .sub_price').text();
        $('.cwr-total-you-save__price .save-price__text').text(lastProductSave);
        $('.subscribe-toggle-box .subtext').text('Unlock free shipping with subscriptions');
        $('.subscribe-toggle-box').removeClass('active');
        var get_text = $('.cwr-choose-quantity__products_onetime .product__card input:checked').attr('id');
        if(get_text.includes('2-bottle')){
          $('.cwr-total-you-save__price .best-deal__text').show();
        }else{
          $('.cwr-total-you-save__price .best-deal__text').hide();
        }
      }
  });  

  $(document).on('change','.product__card input', function(e){
      let seletor_vid = $(this).attr('data-variant-id');
      $('.form--product-details-new input[name="variantid"]').val(seletor_vid);
      let selcetor_saveprice = $(this).attr('data-saving-price');
      $('.cwr-total-you-save__price .save-price__text').text(selcetor_saveprice);
      var get_text = $(this).attr('id');
      if(get_text.includes('2-bottle')){
        $('.cwr-total-you-save__price .best-deal__text').show();
      }else{
        $('.cwr-total-you-save__price .best-deal__text').hide();
      }
  });

  $('.frequancy_selector').on('change', function(e){
    var selectedOption = $(this).find(':selected');
    let planId  = selectedOption.data('id');
    console.log('plan id', planId);
    $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', planId);
  });


  // on page load get id's start
    let get_planId = $('.frequancy_selector option:selected').attr('data-id');
    $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', get_planId);
    let var_id = $('.product__card.subscribe-on input:checked').attr('data-variant-id');console.log(var_id);
    $('.form--product-details-new input[name="variantid"]').val(var_id);
    var lastProductSave = $('.product__card.subscribe-on input:checked').closest('.product__card').find('.sub_price').text();
    $('.cwr-total-you-save__price .save-price__text').text(lastProductSave);

  // on page load get id's end

  // Add prodduct code
  $('.form--product-details-new').on('submit', function(e){
    e.preventDefault();
    var itemsArray = [];
    if ($('#subscribeToggle').is(':checked')) {   
      var var_id  = $('.form--product-details-new input[name="variantid"]').val();
      var selling_plan_id = $('.form--product-details-new input[name="variantid"]').attr('data-selling-id');
      var customItem = [
        {
            id: var_id,
            quantity: 1,
            selling_plan: selling_plan_id,
            properties: {
              _islandingpage: "true"
            }
          }
      ];
      itemsArray.push(...customItem);
      
    }else{
        var var_id  = $('.form--product-details-new input[name="variantid"]').val();
        var customItem = { id: var_id, quantity: 1 ,
          properties: {
            _islandingpage: "true"
          }                 
          };
        itemsArray.push(customItem);
    }

    $.ajax({
        url: '/cart/add.js',
        method: "POST",
        dataType: "JSON",
        data: { items: itemsArray },
        success: function (data) {
          $.getJSON('/cart.js', function(data) {
            let cart_count = data.item_count;
        
            // Check if .cart__count exists, if not, create it inside #dCartBtn as the last child
            if ($('.cart__count').length === 0) {
                $('#dCartBtn').append('<span class="cart__count"></span>');
            }
        
            // Update .cart__count content if the element exists and cart_count is a number
            if (cart_count !== undefined && typeof cart_count === "number") {
                $('.cart__count').html(cart_count);
            }
        }).fail(function(error) {
            console.error('Error fetching cart data:', error);
        });
        },
        error: function (data) {
        }
    });
  });


  // widget-v2 code start
  if($('.cwr-product__custom-radio').length){
    $(document).on('change','.cwr-product__custom-radio .radio__option input', function(){
      let selectoreVal = $(this).val();
        const isChecked = $('#subscribeToggle').is(':checked');
        if (isChecked) {
          $('.cwr-choose-quantity__products_subscribe .cwr-choose-quantity__products .size-group-wrapper').each(function(ie,em){
            let Title = $(em).attr('data-title');
            if(selectoreVal == Title){
              $(em).show();
              let selling_plan_id = $(em).find('.product__card.subscribe-on input:checked').attr('data-selling-id');
              let varaint_id = $(em).find('.product__card.subscribe-on input:checked').attr('data-variant-id');
              console.log('selling_plan_id',selling_plan_id)
              $('.form--product-details-new input[name="variantid"]').attr('data-selling-id', selling_plan_id);
              $('.form--product-details-new input[name="variantid"]').val(varaint_id);
              let lastProductSavess = $(em).find('.product__card.subscribe-on input:checked').next('.product__card-inner').find('.product__save-block .save-tag .sub_price').text();              
              $('.cwr-total-you-save__price .save-price__text').text(lastProductSavess);
            }else{
              $(em).hide();
            }
          })
        }else{
            $('.cwr-choose-quantity__products_onetime .cwr-choose-quantity__products .size-group-wrapper').each(function(ie,em){
            let Title = $(em).attr('data-title');
            if(selectoreVal == Title){
              $(em).show();
              let varaint_id = $(em).find('.product__card input:checked').attr('data-variant-id');
              console.log('varaint_id',varaint_id);
              $('.form--product-details-new input[name="variantid"]').attr('data-selling-id','');
              $('.form--product-details-new input[name="variantid"]').val(varaint_id);
              let lastProductSaveontime = $(em).find('.product__card input:checked').next('.product__card-inner').find('.product__save-block .save-tag .sub_price').text();             
              $('.cwr-total-you-save__price .save-price__text').text(lastProductSaveontime);
            }else{
              $(em).hide();
            }
          })
        }
    });
  }

  // Remove from cart code start for new widget logic
  $(document).on('click', '.remove-button', function(event) {
    event.preventDefault();

    let vID = $(this).data('vid');
    console.log('Main product ID to remove:', vID);

    let updates = {};

    $('.cart-list .item').each(function() {
      const $itemRow = $(this);

      const itemVID = $itemRow.data('vid');
      const isFreeProduct = $itemRow.data('is-free-product');
      const mainProductID = $itemRow.data('main-product');
      const lineItemKey = $itemRow.data('key'); // Make sure this is available!

      // Remove main product
      if (itemVID === vID) {
        console.log('Removing main product:', itemVID);
        updates[lineItemKey] = 0;
      }

      // Remove free product linked to the main product
      if (isFreeProduct && mainProductID && mainProductID.toString().split(',').includes(vID.toString())) {
        console.log('Removing free product linked to:', mainProductID);
        updates[lineItemKey] = 0;
      }
    });

    if (Object.keys(updates).length > 0) {
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: JSON.stringify({ updates: updates }),
        dataType: 'json',
        contentType: 'application/json',
        success: function(cart) {
          console.log('Items removed successfully. Cart:', cart);
          location.reload(); // Refresh or update cart UI as needed
        },
        error: function(xhr, textStatus, errorThrown) {
          console.error('Error removing items:', errorThrown);
          if (xhr.status === 429) {
            setTimeout(() => location.reload(), 2000);
          } else {
            location.reload();
          }
        }
      });
    } else {
      window.location.href = $(this).attr('href');
    }
  });

  // Free Dream bubble slider
  if ($(".js-cwr-free-dreambubbles-pdp-slider-for").length > 0) {
    $('.js-cwr-free-dreambubbles-pdp-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: true,
        fade: true,
        dots: true,
        appendDots: $(".js-cwr-free-dreambubbles-pdp-slider-dots"),
        prevArrow: '<button type="button" class="slick-prev custom-prev"><svg stroke="#000" fill="#000" stroke-width="0" viewBox="0 0 16 16" role="presentation" style="width:var(--rsw, 100%);height:100%" class="r-v6le6u" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next custom-next"><svg stroke="#000" fill="#000" stroke-width="0" viewBox="0 0 16 16" role="presentation" style="width:var(--rsw, 100%);height:100%" class="r-c0jod5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"></path></svg></button>'
    });
  }
});
